<script setup lang="ts">
import { useNameButton, type NameButtonProps } from '../../composables/button/useNameButton'

const props = defineProps<NameButtonProps>()

const { image } = useNameButton(props)
</script>

<template>
  <button class="name-button">
    <img class="hilight" :src="image.hilight" />
    <img :src="image.name" />
  </button>
</template>

<style scoped>
.name-button {
  position: absolute;
  padding: 0;
  background: none;
  border: none;
  cursor: pointer;
  z-index: 2;
}

.name-button .hilight {
  position: absolute;
  opacity: 0;
}

.name-button.blink .hilight {
    animation: fadeInOut 2s ease-in-out;
}

/* prettier-ignore */
@keyframes fadeInOut {
    0% { opacity: 0; }
    50% { opacity: 1; }
    100% { opacity: 0; }
}

</style>
